//Include Both Helper File with needed methods
import {
  loginSuccess,
  logoutUserSuccess,
  apiError,
  reset_login_flag,
  twoFactorPending,
  passwordExpiredPending,
} from './reducer';
import {
  login,
  confirmTwoFactor,
  resendTwoFactor,
  changeExpiredPassword,
} from '../../../helpers/bff_helper';
import { toast } from 'react-toastify';
import { createAbility } from '../../../helpers/casl';

const errOpts = {
  className: 'bg-danger text-white',
  position: 'top-center',
};

const completeLogin = (dispatch, data) => {
  sessionStorage.setItem('authUser', JSON.stringify(data));
  dispatch(loginSuccess(data));

  return data?.permissions?.reduce(
    (acc, { subject }) => (acc = [...acc, subject]),
    []
  );
};

export const loginUser = (user) => async (dispatch) => {
  try {
    const data = await login(user.email, user.password, user.recaptchaToken, user.location);

    // OP-014: password expired — user must change before session is issued
    // BFF's SnakeCamelInterceptor snake_cases response bodies, so these arrive as password_expired/password_change_token
    if (data?.password_expired) {
      dispatch(passwordExpiredPending({ passwordChangeToken: data.password_change_token }));
      return { passwordExpired: true };
    }

    if (data?.pending2fa) {
      dispatch(twoFactorPending({ pendingToken: data.pending_token, method: data.method }));
      return { pending2fa: true };
    }

    if (data) {
      return completeLogin(dispatch, data);
    }

    toast.error('Ops! Houve um erro. Tente novamente em instantes', errOpts);
  } catch (error) {
    dispatch(apiError(error));
    toast.error(error, errOpts);
  }
};

export const changeExpiredPasswordThunk =
  (passwordChangeToken, newPassword, recaptchaToken, location) => async (dispatch) => {
    try {
      const data = await changeExpiredPassword(passwordChangeToken, newPassword, recaptchaToken, location);

      // If 2FA is enabled, account returns pending2fa branch — hand off to the 2FA step
      if (data?.pending2fa) {
        dispatch(twoFactorPending({ pendingToken: data.pending_token, method: data.method }));
        return { pending2fa: true };
      }

      if (data) {
        return completeLogin(dispatch, data);
      }

      toast.error('Ops! Houve um erro. Tente novamente em instantes', errOpts);
    } catch (error) {
      dispatch(apiError(error));
      // Show a friendlier message for reused-password
      const message =
        error?.response?.data?.detail === 'password_reused'
          ? 'Essa senha já foi usada recentemente. Escolha uma senha diferente.'
          : error?.response?.data?.detail || error?.response?.data?.title || error?.message || 'Erro ao trocar a senha.';
      toast.error(message, errOpts);
      return { error: true };
    }
  };

export const confirmTwoFactorCode = (pendingToken, code) => async (dispatch) => {
  try {
    const data = await confirmTwoFactor(pendingToken, code);

    if (data) {
      return completeLogin(dispatch, data);
    }

    toast.error('Ops! Houve um erro. Tente novamente em instantes', errOpts);
  } catch (error) {
    dispatch(apiError(error));
    toast.error(error, errOpts);
  }
};

export const resendTwoFactorCode = (pendingToken) => async (dispatch) => {
  try {
    await resendTwoFactor(pendingToken);
  } catch (error) {
    dispatch(apiError(error));
    toast.error(error, errOpts);
  }
};

export const logoutUser = () => async (dispatch) => {
  try {
    sessionStorage.removeItem('authUser');
    dispatch(logoutUserSuccess(true));
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const resetLoginFlag = () => async (dispatch) => {
  try {
    const response = dispatch(reset_login_flag());
    return response;
  } catch (error) {
    dispatch(apiError(error));
  }
};
